import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { IPortalLink } from '@nha/api/core';
import { LeaveFadeOutAnimation } from '@nha/components/animations/leave-fade-out.animation';
import { Observable } from 'rxjs';
import { filter, take, withLatestFrom } from 'rxjs/operators';
import { PortalLinkFacade } from './state';
import { NHASearchBoxComponent } from '../search-box/search-box.component';
import { NHAPortalLinkComponent } from './components/portal-link/portal-link.component';
import { NHALoaderComponent } from '../loader/loader.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { NHATestDirective } from '../../directives/test/test.directive';
import { NHAPopupComponent } from '../popup/popup.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'nha-app-launcher',
	templateUrl: `app-launcher.component.html`,
	styleUrls: [`./app-launcher.component.scss`],
	encapsulation: ViewEncapsulation.None,
	animations: [LeaveFadeOutAnimation],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		NHAPopupComponent,
		NHATestDirective,
		MatButtonModule,
		MatTabsModule,
		NHALoaderComponent,
		NHAPortalLinkComponent,
		NHASearchBoxComponent,
		MatIconModule
	]
})
export class NHAAppLauncherComponent implements AfterViewInit {
	private portalLinkFacade = inject(PortalLinkFacade);

	@ViewChild('tabGroup', { read: MatTabGroup }) tabGroup: MatTabGroup;

	public initialTab: 0 | 1 = 0;
	public searchText: string;
	public applicationLinks$: Observable<IPortalLink[]> = this.portalLinkFacade.allActivePortalLinks$;
	public favorites$: Observable<IPortalLink[]> = this.portalLinkFacade.selectFavorites$;

	public filteredLinkList$: (searchText: string) => Observable<IPortalLink[]> = this.portalLinkFacade.filteredLinkList$;

	public isLoading$: Observable<boolean> = this.portalLinkFacade.isLoading$;

	ngAfterViewInit(): void {
		this.portalLinkFacade.isLoaded$.pipe(filter(Boolean), take(1), withLatestFrom(this.favorites$)).subscribe(([_, favorites]) => {
			this.initialTab = favorites.length > 0 ? 0 : 1;
		});
	}

	openChanged(isOpen: boolean): void {
		if (isOpen) {
			this.portalLinkFacade.loadPortalLinks();

			this.portalLinkFacade.isLoaded$.pipe(filter(Boolean), take(1)).subscribe(() => {
				this.tabGroup.realignInkBar();
			});
		}
	}
}
